<template>
<div class="container-body login-body-color" >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div
          class="card o-hidden border-0 shadow-lg my-5 login-border-radius" 
        >
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6">
                <img src="./loginPageBanner.png" class="login-logo" alt="logo"  />
              </div>
               
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-left">
                    <h1 class="h4 text-gray-900 mb-4">
                      {{ $t("ForgotYourPassword") }}
                    </h1>
                    <br />
                  </div>
                                      <p class="text-left">{{ $t("ForgotPassWordMessage") }}</p>

                   <br />
                  <form class="user"  @submit.prevent="sendmail">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control form-control-user"
                        id="exampleInputEmail"
                        v-model.trim="$v.credintialForm.userid.$model"
                        :placeholder="$t('LOGINID')"
                        autocomplete="off"
                      />
                      <show-errors
                        :control="$v.credintialForm.userid"
                        :field="$t('MANDATORY')"
                      />
                    </div>

                    <button
                      class="btn btn-primary btn-user btn-block"
                     type="submit"
                    >
                      {{ $t("RESETPASSWORD") }}
                    </button>
                    
                    
                  </form>
                   <br />
                      <br />
                         <br />

                            <br />

                  <div class="text-center">
                    <a class="small" href="#/login">{{ $t("LOGINHERE") }}!</a>
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { SEND_RESET_LINK } from "@/store/actions.type";
import ShowErrors from "@/components/ShowErrors";

export default {
  name: "Login",
  components: { ShowErrors },
  data() {
    return {
      credintialForm: {
        userid: ""
      }
    };
  },
  validations: {
    credintialForm: {
      userid: { required }
    }
  },
  methods: {
    sendmail() {
      this.$v.$touch();
      if (!this.$v.credintialForm.$invalid) {
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        this.$store
          .dispatch(SEND_RESET_LINK, this.credintialForm)
          .then(data => {
            this.isLoading.hide();
            if (data.status) {
              this.$toast.success({
                message: data.message
              });
            } else {
              this.$toast.error({
                message: data.message
              });
            }
          });
      }
    }
  }
};
</script>
<style>
.IconLogo {
  height: 18%;
  margin: 5%;
}
.container-body {
            position: absolute;
            width: 100%;
            min-height: 100%;
            left: 0;
            top: 0;
        }
</style>
